// 5-star Google reviews to display in the trust strip above the CTA.
// To add a new review, just append a new object below. The component handles
// 1, 2, 3+ reviews automatically (centered single card / row / marquee scroll).
export const GOOGLE_REVIEWS = [
  {
    id: "zoltan-fenyvesi",
    name: "Zoltán Fenyvesi",
    rating: 5,
    text: "Szakszerű tisztítás, pontos munkavégzés! Köszönet a munkáért!",
    date: { hu: "Nemrég", en: "Recently", de: "Vor kurzem", nl: "Onlangs" },
  },
  {
    id: "zoltan-hetesi",
    name: "Zoltán Hetesi",
    rating: 5,
    text: "Maximálisan elégedett vagyok a szolgáltatással. Pontos érkezés, precíz és alapos munkavégzés, és ami számomra szintén nagyon fontos: tiszta munkaterületet hagytak hátra. Az áraik abszolút korrektek és megfizethetőek. Ötcsillagos, profi hozzáállás, csak ajánlani tudom a céget!",
    date: { hu: "Nemrég", en: "Recently", de: "Vor kurzem", nl: "Onlangs" },
  },
  {
    id: "sandor-balint",
    name: "Sandor Balint",
    rating: 5,
    text: "Nagyon pontos korrekt kiszolgálás, mindenre kiterjed a figyelmük. Ajánlom mindenkinek őket!!",
    date: { hu: "Nemrég", en: "Recently", de: "Vor kurzem", nl: "Onlangs" },
  },
  {
    id: "horoczi-erika",
    name: "Dr. Horóczi Erika",
    rating: 5,
    text: "Minden tekintetben meg voltunk elégedve, tisztán rendben ment a klímatisztítás, kedves, közvetlen emberek. Abszolút ajánlom.",
    date: { hu: "Nemrég", en: "Recently", de: "Vor kurzem", nl: "Onlangs" },
  },
  {
    id: "andor-kelemen",
    name: "Andor Kelemen",
    rating: 5,
    text: "A-team 3 klímát tisztított nálunk, Balatonszárszón. Olyan alapos mélytisztítást végeztek, amilyet még sehol sem láttunk korábban. Beltéri + kültéri egység tisztítása. Pontosan érkeztek, nagyon kedvesek, korrekt áron dolgoznak. Maximálisan elégedettek vagyunk. Mindenkinek csak ajánlani tudjuk.",
    date: { hu: "Nemrég", en: "Recently", de: "Vor kurzem", nl: "Onlangs" },
  },
];
